import React from 'react'
import AnimatedContent from './Animations/AnimatedContent'
import Typewriter from 'typewriter-effect';

export default function Hero() {
  return <div className='header flex items-center justify-center md:h-[58vw] h-[110vw]  px-[5vw] md:pb-0 pb-14 relative'>
    <img src="/images/star.png" alt="" className='md:w-[2vw] w-[8vw]  absolute md:top-[15vw] top-[22vw] left-[20vw]  blink_animation' />
    <img src="/images/star.png" alt="" className='md:w-[2vw] w-[8vw]  absolute bottom-[13vw] left-[15vw] blink_animation' />
    <img src="/images/star.png" alt="" className='md:w-[2vw] w-[8vw]  absolute bottom-[18vw] md:right-[46vw] right-[6vw] blink_animation' />
    <div className='flex flex-col justify-center items-center lg:pt-0 md:pt-[10vw] pt-[20vw] relative z-10'>

      <AnimatedContent
        distance={150}
        direction="vertical"
        reverse={false}
        config={{ tension: 80, friction: 20 }}
        initialOpacity={0.2}
        animateOpacity
        scale={1.1}
        threshold={0.2}
      >
        <h1 className="md:text-9xl text-5xl font-extrabold text-center">
          <Typewriter
            options={{
              strings: ['Vocal AI',],
              autoStart: true,
              loop: true,
            }}
          />
        </h1>
      </AnimatedContent>




      <AnimatedContent
        distance={150}
        direction="horizontal"
        reverse={false}
        config={{ tension: 80, friction: 20 }}
        initialOpacity={0.2}
        animateOpacity
        scale={1.1}
        threshold={0.2}
      >
        <p className='text-2xl my-3 text-center'>The Future of Crypto Trading, Powered by Your Voice</p>
      </AnimatedContent>


      <div className='flex items-center md:gap-5 gap-3 mt-5'>

        <AnimatedContent
          distance={150}
          direction="vertical"
          reverse={false}
          config={{ tension: 80, friction: 20 }}
          initialOpacity={0.2}
          animateOpacity
          scale={1.1}
          threshold={0.2}
        >
          <a href="https://t.me/VocalAiPortal" target="_blank" rel="noopener noreferrer">
            <button class="bg-white text-black md:px-10 px-6 md:py-4 py-3 md:text-base text-sm text-nowrap rounded-full">Join Community </button>
          </a>
        </AnimatedContent>
        <AnimatedContent
          distance={150}
          direction="vertical"
          reverse={false}
          config={{ tension: 80, friction: 20 }}
          initialOpacity={0.2}
          animateOpacity
          scale={1.1}
          threshold={0.4}
        >
          <a href="">
            <button class="btn1 md:px-10 px-6 md:py-4 py-3 md:text-base text-sm text-nowrap rounded-full">Learn More</button>
          </a>
        </AnimatedContent>


      </div>

    </div>
    <img src="/images/about.gif" alt="" className='lg:w-[50vw] -z-1 md:w-[30vw] w-[60vw] lg:h-[50vw] md:h-[30vw] h-[60vw] absolute md:-right-[10vw] -right-[15vw] -top-[15vw] mx-auto rounded-full' />
  </div>
}
